import { getCurrentUser } from "@/db/indexedDB";
import { ICustomer } from "@/api/services/CustomerService";


let userdata: ICustomer | null = null;

export async function initializeUser(user?: ICustomer): Promise<void> {
  try {
    if (user) {
      userdata = user;
    } else {
      userdata = await getCurrentUser();
    }
  } catch (error) {
    console.error('No user found!', error);
    userdata = null;
  }
}

export function getUserId(): string | null {
  return userdata?.id ?? null;
}

export function clearUserId(): void {
  userdata = null;
}

